import { Field } from 'formik';
import React from 'react';
import { Select as AntdSelect, Checkbox, Radio } from 'antd';
import PropTypes from 'prop-types';
import Status from '../status';
import style from './style.module.scss';

const { Option } = AntdSelect;

const Select = ({
  name,
  options = [],
  placeholder,
  isDisabled = false,
  label,
  isMultiSelect = false,
  isRequired = false,
  suffixIcon,
  onChangeExtended = () => {},
}) => {
  return (
    <Field name={name}>
      {({ field, form, meta: { error, touched } }) => {
        const value = field.value;
        const valueArray = Array.isArray(value) ? value : [];

        return (
          <div className={style['input-wrapper']}>
            {isRequired && (
              <p className={style['required-check']}>
                <Status
                  isFilled={
                    !error &&
                    ((Array.isArray(value) && value.length > 0) ||
                      (typeof value === 'string' && value.trim() !== '') ||
                      typeof value === 'number')
                  }
                />
              </p>
            )}

            <div className={style['label-box']}>
              <p className={style['label']}>{label}</p>

              <div className={style['box']}>
                <AntdSelect
                  className={style['custom-select']}
                  popupClassName={style['custom-select-dropdown']}
                  mode={isMultiSelect ? 'multiple' : undefined}
                  value={value}
                  placeholder={placeholder}
                  disabled={isDisabled}
                  onChange={(val) => {
                    form.setFieldValue(name, val);
                    onChangeExtended(val);
                  }}
                  onBlur={() => form.setFieldTouched(name, true)}
                  maxTagCount="responsive"
                  optionLabelProp="label"
                  dropdownMatchSelectWidth={true}
                  status={touched && error ? 'error' : ''}
                  suffixIcon={suffixIcon}>
                  {options.map((item) => {
                    const id = item.id;
                    const labelText = item.name;
                    const checked = isMultiSelect ? valueArray.includes(id) : value === id;

                    return (
                      <Option key={id} value={id} label={labelText}>
                        <div className={style['dropdown-option']}>
                          <span>{labelText}</span>
                          {isMultiSelect ? (
                            <Checkbox checked={checked} />
                          ) : (
                            <Radio checked={checked} />
                          )}
                        </div>
                      </Option>
                    );
                  })}
                </AntdSelect>
                {touched && error && <p className={style['error']}>{error}</p>}
              </div>
            </div>
          </div>
        );
      }}
    </Field>
  );
};

Select.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  isMultiSelect: PropTypes.bool,
  isRequired: PropTypes.bool,
};

export default Select;
